import React from 'react'
import Layout from '../../Components/Layout'
import BannerGlobal from '../../Components/BannerGlobal'
import ServiceDetails from '../../Components/ServiceDetails'
import useDocumentTitle from '../../Hooks/PageTitle'

const ServiceDetailsPage = () => {
  useDocumentTitle("TRoo Web Design Agency | Service Details")
  return (
   <Layout>
    <BannerGlobal/>
    <ServiceDetails/>
   </Layout>
  )
}

export default ServiceDetailsPage